<template>
  <v-footer app class="footer-app txt-normal py-0">
    <v-layout justify-space-between align-center>
      <v-flex xs12 sm6 md9>
        <v-row align="center">
          <v-col
            cols="auto"
            sm="auto"
            md="auto"
            lg="auto"
            class="d-flex align-center"
          >
            <!--v-icon color="#75BF71">mdi-phone</v-icon>
            <span class="font-14 font-w-500" style="color: #75bf71">
              : 1365</span
            -->
            <div
              v-if="$vuetify.breakpoint.smAndUp"
              class="font-14 font-w-400"
              style="padding-left: 70px"
            >
              Contact Us
            </div>
            <div v-else class="font-14 font-w-400" style="padding-left: 50px">
              Contact Us
            </div>
          </v-col>
          <v-col
            cols="auto"
            sm="auto"
            md="auto"
            lg="auto"
            class="d-flex align-center cursor-pointer"
          >
            <a
              @click="dialogQRCode = true"
              rel="noopener noreferrer"
              class="d-flex align-center cursor-pointer"
            >
              <img
                width="25"
                height="25"
                aspect-ratio="1"
                :src="require('../assets/img/line.png')"
              />
              <span class="font-14 font-w-500" style="color: #75bf71">
                : @AMZconnect
              </span>
            </a>
          </v-col>
          <!--v-col
            cols="12"
            sm="12"
            md="auto"
            lg="auto"
            class="d-flex align-center"
          >
            <v-icon color="#75BF71">mdi-email</v-icon>
            <a
              href="mailto:amz-connect@pttor.com"
              style="color: #75bf71; text-decoration: none"
            >
              <span class="font-14 font-w-400">
                : amz-connect@pttor.com
              </span>
            </a>
          </v-col-->
        </v-row>
      </v-flex>
      <v-flex
        v-if="$vuetify.breakpoint.smAndUp"
        xs12
        sm6 md9
        class="d-flex justify-sm-end justify-start font-14 font-w-500 my-3 my-sm-0"
      >
        <a href="https://pdpa.pttor.com/privacyPolicy/31" target="_blank">
          นโยบายความเป็นส่วนตัว </a
        >&nbsp;|&nbsp;
        <a href="https://pdpa.pttor.com/cookiesPolicy" target="_blank">
          นโยบายการใช้คุกกี้
        </a>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogQRCode" width="440" overlay-opacity="0.8">
      <v-card width="400" flat class="pa-6" style="border-radius: 12px">
        <div class="text-center mb-2">
          <span class="font-20 font-w-600"
            >สแกน QR Code เพื่อเพิ่มเพื่อนใน LINE</span
          >
        </div>
        <v-layout justify-center mt-2>
          <v-flex shrink>
            <v-img
              width="280"
              height="280"
              aspect-ratio="1"
              :src="
                require('../assets/img/gainfriends_2dbarcodes_G.png')
              "
            ></v-img>
          </v-flex>
        </v-layout>
        <div class="text-center mt-2">
          <img
            width="46"
            height="46"
            aspect-ratio="1"
            :src="require('../assets/img/line2.png')"
          />
          <br />
          <span class="font-18 font-w-600">@AMZconnect</span>
        </div>
      </v-card>
    </v-dialog>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      dialogQRCode: false,
    };
  },
};
</script>

<style scoped>
a {
  color: var(--theme-color-one) !important;
  text-decoration: none;
}
.footer-app {
  /* display: flex; */
  min-height: var(--footer-height);
  /* max-height: var(--footer-height); */
  /* justify-content: end; */
  /* align-items: center; */
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14),
    0 0 4px 0 rgba(0, 0, 0, 0.12) !important;
  background: #fff;
  z-index: 99;
}
</style>
